if (!customElements.get('rich-text-section')) {
  customElements.define('rich-text-section', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.columns !== '2' || this.dataset.columnsReady === 'true') return;

      const content = this.querySelector(':scope > .rich-text__content');
      if (!content) return;

      const nodes = Array.from(content.children);
      const totalLength = nodes.reduce((length, node) => length + node.textContent.trim().length, 0);
      const midpoint = totalLength / 2;
      let traversedLength = 0;
      let splitIndex = -1;

      nodes.forEach((node, index) => {
        if (splitIndex < 0 && node.tagName === 'H2' && index > 0 && traversedLength >= midpoint) {
          splitIndex = index;
        }
        traversedLength += node.textContent.trim().length;
      });

      if (splitIndex < 0) return;

      const columns = this.createColumns(nodes, splitIndex);
      content.replaceWith(columns);
      this.dataset.columnsReady = 'true';
    }

    createColumns(nodes, splitIndex) {
      const columns = document.createElement('div');
      const firstColumn = document.createElement('div');
      const secondColumn = document.createElement('div');
      columns.className = 'rich-text__columns';
      firstColumn.className = 'rich-text__column';
      secondColumn.className = 'rich-text__column';

      nodes.forEach((node, index) => {
        const target = index < splitIndex ? firstColumn : secondColumn;
        target.appendChild(node);
      });

      columns.append(firstColumn, secondColumn);
      return columns;
    }
  });
}
